import { Link } from "gatsby"
import React from "react"

import { FaTags } from "../../../AppReactIcons"
import { BreadcrumbType } from "./types"

const Breadcrumbs: React.FC<{ breadcrumbs?: BreadcrumbType[] }> = ({
  breadcrumbs,
}) => {
  if (!breadcrumbs) return null
  return (
    <>
      <p className="leading-no text-base flex items-center">
        <span className="mr-2">
          <FaTags />
        </span>
        {breadcrumbs.map((item, index) => {
          if (index === breadcrumbs.length - 1) return null
          return (
            <Link to={item.link} key={index}>
              <span className="hover:underline">{item.title}</span>/
            </Link>
          )
        })}
      </p>
      <Link to={breadcrumbs[breadcrumbs.length - 1].link}>
        <h3 className="font-thin hover:underline text-xl text-site-blue-dark">
          {breadcrumbs[breadcrumbs.length - 1].title}
        </h3>
      </Link>
    </>
  )
}

export default Breadcrumbs
